import { ContentTypeFilterClause, ExplorableItemDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { RunFlowTaskContentType } from '../ContentTypes';
import { getGenericDefaultFilters } from './getDefaultFilters';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { RunFlowTasks } from '../../resources/RunFlowTasks';

export const RunFlowTaskDefinition: ExplorableItemDefinition = {
  itemType: 'runFlowTask',
  pluralName: Messages.flows,
  emptyStateMessage: Messages.flowsEmptyMessage,
  contentFilterKeys: RunFlowTaskContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: null,
  listViewIconUrl: '', // we don't display an icon for run flow tasks runs
  filterClause: ServerFilterClauses.ContentType(['runFlowTask']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return RunFlowTasks.all().withExtraParams(RunFlowTaskContentType.extraQueryParams);
  },
  getContentInfo: () => {
    throw new Error('getContentInfo is not implemented for runFlowTask');
  },
  supportedDisplayModes: ['list']
};
